import type { IconProps } from "types";

const Titles = ({ width = "20", height = "20" }: IconProps) => (
  <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5 2.91663H17.5" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" />
    <path d="M2.5 17.0834H17.5" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" />
    <path
      d="M9.99999 5.41663L5.83333 14.5833"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 11.6666H12.5"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 5.41663L14.1667 14.5833"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Titles;
